import {RegionType} from "@pg-rp/common-types";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {RecommendationPropertyDefaultDistance} from "../constants/RecommendationPropertyDefaultDistance";

export const getRecommendationFromProperty = (property: IPropertyDetail, distance?: number) => {
    const recommendationProperty = {
        ...property,
        distance: distance ?? RecommendationPropertyDefaultDistance,
        region: {
            country: property.offer.region.country,
            id: property.offer.region.id,
            type: property.offer.region.type as RegionType,
            parent: property.offer.region.parent
                ? {
                      id: property.offer.region.parent.id,
                      type: property.offer.region.type as RegionType
                  }
                : undefined
        },
        offer: {
            ...property.offer,
            geo_point: {
                type: "Point",
                coordinates: property.offer.geo_point.coordinates
            }
        }
    };
    return recommendationProperty;
};
